const classMap = {
  success: 'login-form-success',
  error:   'login-form-error',
  loading: 'login-form-loading',
};

function FormFeedback({ type, message }) {
  if (!message) return null;
  return <div className={classMap[type] ?? 'login-form-error'}>{message}</div>;
}

export { FormFeedback };
